gsap.registerPlugin(ScrollToPlugin);

// Fade Animations for every page
var fadeInElems = gsap.utils.toArray(".fade.fadeIn");
fadeInElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        ease: 'sine.out',
        duration: 2,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeUpElems = gsap.utils.toArray(".fade.fadeUp");
fadeUpElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        y: 15,
        ease: 'sine.out',
        duration: 2,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeLeftElems = gsap.utils.toArray(".fade.fadeLeft");
fadeLeftElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        x: -15,
        ease: 'sine.out',
        duration: 1,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

var fadeRightElems = gsap.utils.toArray(".fade.fadeRight");
fadeRightElems.forEach(function(elem) {
    gsap.from(elem, {
        autoAlpha: 0,
        x: 15,
        ease: 'sine.out',
        duration: 1,
        scrollTrigger: {
            trigger: elem,
            start: "top 75%"
        }    
    })
})

window.addEventListener("load", (event) => {
    var workWithUsButton = document.querySelector('#work_with_us');
    gsap.to(workWithUsButton, {
        autoAlpha: 0,
        scale: .9,
        scrollTrigger: {
            trigger: workWithUsButton,
            start: document.querySelector('.page').getBoundingClientRect().bottom,
            toggleActions: "restart none none reverse"
        }
    });
});

// Homepage Animations
window.initHomepageAnims = function () {
    let mm = gsap.matchMedia();
    mm.add("(min-width: 991px)", () => {
        var homepageLandingTL = gsap.timeline()
        // homepageLandingTL.from('.landing .content .title.one', {
        //     autoAlpha: 0,
        //     y: 15,
        //     ease: 'sine.out',
        //     duration: 1
        // })
        homepageLandingTL.from('.landing .content .showreel-toggle svg', {
            autoAlpha: 0,
            y: 15,
            ease: 'sine.out',
            duration: 1
        }, "<.5")
    });

    let homepageSericeNav = document.querySelector('#services_navigation');
    var homepageServices = gsap.utils.toArray(".service-card");
    homepageServices.forEach((card, i) => {
        // Get remaining items height to see when pin should end
        let remainingItemsHeight = 0;
        for (let x = i+1; x < homepageServices.length; x++) {
            remainingItemsHeight+=(homepageServices[x].clientHeight+8);
        }
        gsap.to(card, {
            scrollTrigger: {
                trigger: card,
                start: 'center center',
                end: '+=' + remainingItemsHeight + 'px',
                pin: true,
                pinSpacing: false,
                scrub: true,
                // For debugging
                // markers:true
            }
        })
    });

    // Fix nav above cards
    let totalServiceHeight = document.querySelector('.services-cards').clientHeight;
    ScrollTrigger.create({
        trigger: homepageSericeNav,
        pin: homepageSericeNav,
        pinSpacing: false,
        start: "top 110px",
        end: "+=" + totalServiceHeight + 'px',
    })

    // Overwrite service nav scrolling
    gsap.utils.toArray("#services_navigation a").forEach(function(a,i) {
        a.addEventListener("click", function(e) {
            e.preventDefault();
            gsap.utils.toArray("#services_navigation a").forEach(function(a,i) {
                a.classList.remove('active');
            });
            a.classList.add('active');
            let target_card = document.querySelector(a.getAttribute('href'));
            let scrollPosition = document.documentElement.scrollTop + target_card.getBoundingClientRect().top - 180;
            gsap.to(window, {duration: 0.2, scrollTo: scrollPosition, overwrite: true});
        })
    });
}

// Ticker animations
window.initTickers = function () {
    const speed = 50;
    let tickerWidth = document.querySelector(".ticker-items").offsetWidth;
    let initDuration = tickerWidth / speed;

    gsap.to(".ticker-items", {
        duration: initDuration,
        xPercent: -100,
        ease: "none",
        repeat: -1
    });
}

// Service Animations
window.initServiceAnims = function () {
    let mm = gsap.matchMedia();
    let processSteps = gsap.utils.toArray("#process_steps .step");
    let processHeading = document.querySelector("#process_heading");
    let processSection = document.querySelector("#our_process");
    mm.add("(min-width: 991px)", () => {
        if (processSteps.length) {
            ScrollTrigger.create({
                // markers: true,
                trigger: processSection,
                pin: processHeading,
                pinSpacing: true,
                start: "top 84px",
                end: () => "+=" + (processSteps[processSteps.length-1].getBoundingClientRect().top - processSteps[0].getBoundingClientRect().top),
            });
        } 
    });
}

window.initAboutUsAnims = function () {
    let mm = gsap.matchMedia();
    let belief_items = gsap.utils.toArray(".item");

    mm.add("(min-width: 1400px)", () => {
        gsap.to(belief_items, {
            xPercent: -60 * (belief_items.length - 1),
            ease: "none",
            scrollTrigger: {
              trigger: ".intro-with-items",
              start: "top 15%",
              pin: true,
              scrub: 1,
              end: () => "+=" + document.querySelector(".intro-with-items").offsetWidth
            }
        });
    })
    mm.add("(min-width: 991px) and (max-width: 1399px)", () => {
        gsap.to(belief_items, {
            xPercent: -70 * (belief_items.length - 1),
            ease: "none",
            scrollTrigger: {
              trigger: ".intro-with-items",
              start: "top 15%",
              pin: true,
              scrub: 1,
              end: () => "+=" + document.querySelector(".intro-with-items").offsetWidth
            }
        });
    })

    let teamMembers = gsap.utils.toArray('.team-list .team-member');
    let teamSection = document.querySelector('.team-grid');
    let teamPhoto = document.querySelector('.photo-wrapper');
    ScrollTrigger.create({
        trigger: teamSection,
        // markers: true,
        pin: teamPhoto,
        pinSpacing: false,
        start: "top 150px",
        end: () => "+=" + (teamMembers[teamMembers.length-1].getBoundingClientRect().top - teamMembers[0].getBoundingClientRect().top - 295),
    });
}

window.initPodcastsAnims = function () {
    let mm = gsap.matchMedia();

    mm.add("(min-width: 991px", () =>{
        const podcastingImage = document.querySelector("img.podcasting");
        const landingTL = gsap.timeline({
            scrollTrigger: {
                trigger: ".landing",
                scrub: true,
                pin: false
            }
        });
        landingTL.fromTo(podcastingImage, {
            yPercent: 20,
            ease: "power1.inOut",
        }, {
            yPercent: -20,
            ease: "power1.inOut",
        });
    })
}